// para dejar las correcciones sin los cambios esteticos, comentar debajo de esta linea y descomentar lo primero.
//los cambios son solamente esteticos. no hay cambios en funcionaolidad (solamente las correcciones o cambios solicitados por el usuario)
"use client"

import { useEffect, useState } from "react"
import { Box, Grid, TextField, Typography, Paper } from "@mui/material"

export default function ResumenImportesComprobante(props) {
    /* ----------------------- ESTADOS & REFS -----------------------*/ 
    const {
        total,
        datosCuerpo,
        neto,
        setnetoGravado,
        otrostributos,
        setotrosTributos,
        tiposIvaSeleccionados,
        saldonoaplic,
        setsaldonoaplic,
        datosImpuestos,
        setdatosPie,
        formatNumber,
        totalMuestro,
        formatoCalculo,
        setSaldoNegativo,
        saldoNegativo,
        // valorPorcentajes,
        // datosPie,
    } = props

    const [diferenciasPorIva, setDiferenciasPorIva] = useState([{}])
    const [ivaTotal, setIvaTotal] = useState(0);

    /* ----------------------- HANDLERS -----------------------*/ 


    /* -----------------------------------HELPERS ------------------------------- */
    const netoGravado = (datosCuerpo, setnetoGravado) => {
        const netoGravado1 = datosCuerpo.reduce((acc, lista) => {
            const subtotalStr = String(lista?.subtotal)
            const subtotalform = subtotalStr.replace(/\./g, "")?.replace(/,/g, ".")
            const gravado = parseFloat(subtotalform) || 0
            return isNaN(gravado) ? acc : acc + gravado
        }, 0)
        const formateado = formatNumber(String(netoGravado1).replace(".", ","))
        // console.log("formateado", formateado);
        
        // setnetoGravado(netoGravado1)
        setnetoGravado(formateado)
    }

    const calcularExtras = (datosImpuestos, setotrosTributos) => {
        const calcular = datosImpuestos.reduce((acc, lista) => {
            const ot = parseFloat(lista?.importe?.replace(/\./g, "")?.replace(/,/g, ".")) || 0
            // console.log("ot", ot);
            
            return isNaN(ot) ? acc : acc + ot
        }, 0)
        setotrosTributos(formatNumber(String(calcular)?.replace(".", ",")))
    };

    const calcularAcumuladoDiferencias = () => {
        const acumuladoDiferencias = {}

        const roundUpToTwoDecimals = (num) => {
            return Math.ceil(num * 100) / 100
        }

        datosCuerpo.forEach((linea) => {
            const idPorcentajeIva = linea?.id_porcentajeiva
            const subtotalIva = parseFloat(String(linea?.subtotal_iva)?.replace(/\./g, "")?.replace(/,/g, "."))
            const subtotal = parseFloat(String(linea?.subtotal)?.replace(/\./g, "")?.replace(/,/g, ".")) || 0
            const diferencia = parseFloat((subtotalIva - subtotal).toFixed(2))
            acumuladoDiferencias[idPorcentajeIva] = (acumuladoDiferencias[idPorcentajeIva] || 0) + diferencia;
        })

        const total = Object.values(acumuladoDiferencias).reduce((acc, valor) => {
            const numero = parseFloat(valor.toFixed(2))
            return acc + numero
        }, 0)


        setIvaTotal(formatNumber(total.toFixed(2).replace(".", ",")))

        setDiferenciasPorIva(acumuladoDiferencias)

        const netoGravadoOk = neto ? formatoCalculo(neto) : 0;
        const otrosTributosOk = otrostributos ? formatoCalculo(otrostributos) : 0;

        //No los podria armar cuando voy a armar el cuerpo de la solicitud ?? 
        const nuevosDatosPie = []

        datosCuerpo.forEach((linea) => {
            const idPorcentajeIva = linea.id_porcentajeiva
            const existingIndex = nuevosDatosPie.findIndex((item) => item.id_porcentajeiva === idPorcentajeIva)
            // console.log(existingIndex);
            
            if (existingIndex !== -1) {
                // console.log(acumuladoDiferencias[idPorcentajeIva]);
                
                nuevosDatosPie[existingIndex] = {
                    ...nuevosDatosPie[existingIndex],
                    importe: roundUpToTwoDecimals(acumuladoDiferencias[idPorcentajeIva]),
                    // importe_neto_gr: roundUpToTwoDecimals(neto),
                    // otros_tributos: roundUpToTwoDecimals(otrostributos),
                    importe_neto_gr: roundUpToTwoDecimals(netoGravadoOk),
                    otros_tributos: roundUpToTwoDecimals(otrosTributosOk),
                }
            } else {
                nuevosDatosPie.push({
                    id_porcentajeiva: idPorcentajeIva,
                    importe_neto_gr: roundUpToTwoDecimals(netoGravadoOk),
                    otros_tributos: roundUpToTwoDecimals(otrosTributosOk),
                    uuid_comprobante: linea.uuid_comprobante,
                    usuario: linea.usuario,
                    importe: roundUpToTwoDecimals(acumuladoDiferencias[idPorcentajeIva]),
                })
            }
        })
        // console.log(nuevosDatosPie);
        
        setdatosPie(nuevosDatosPie)
    }

    const setearSaldo = () => {
        let sumatoria = 0
        datosCuerpo &&
            datosCuerpo.forEach((item) => {
                if (parseFloat(item.subtotal_iva)) {
                    const subt = parseFloat(item.subtotal_iva.replace(/\./g, "")?.replace(/,/g, "."))
                    sumatoria += subt
                }
            })

        const otrosTribOk = parseFloat(otrostributos?.replace(/\./g, "")?.replace(/,/g, "."))
        let saldoNoAplic = (parseFloat(total) - (sumatoria + otrosTribOk)) || 0
        saldoNoAplic = Math.ceil(saldoNoAplic * 100) / 100
        setsaldonoaplic(saldoNoAplic < 0 ? `-${formatNumber(String(saldoNoAplic)?.replace(".", ","))}` : formatNumber(String(saldoNoAplic)?.replace(".", ","))) //tengo que concatenar el 0 porque cuando formateo el nro para mostrarlo en ars, me quita el negativo y no tengo ganas de arreglarlo ahora :).
        if (saldoNoAplic < 0) {
            setSaldoNegativo(true)
        } else {
            setSaldoNegativo(false)
        }
    }

    /* ----------------------- EFFECTS -----------------------*/ 
    useEffect(() => {
        netoGravado(datosCuerpo, setnetoGravado)
    }, [datosCuerpo])

    useEffect(() => {
        calcularExtras(datosImpuestos, setotrosTributos)
    }, [datosImpuestos])

    useEffect(() => {
        calcularAcumuladoDiferencias()
    }, [datosCuerpo, tiposIvaSeleccionados])

    useEffect(() => {
        setearSaldo()
    }, [total, datosCuerpo, otrostributos])


    /*--------------------------------STYLING ---------------------------------- */ 
    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#1f618d",
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#1f618d",
        },
    }

    /*--------------------------------RENDER ---------------------------------- */ 
    return (
        <div>
            <Paper
                elevation={3}
                sx={{
                    background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
                    mt: 1,
                    p: 1,
                    borderRadius: 4,
                    borderLeft: "6px solid #1f618d",
                }}
            >
                <Grid container mb={1} direction={{ xs: "row", sm: "row" }} spacing={1}>
                    <Grid item xs={12} px={1} borderBottom={1} borderColor="#bbb" mb={1} pb={1}>
                        <Box
                            width="100%"
                            role="presentation"
                            sx={{
                                backgroundColor: "#1f618d",
                                color: "white",
                                borderRadius: 2,
                                boxShadow: 2,
                            }}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Typography variant="subtitle1" display="block" textAlign="center" fontWeight="bold">
                                IMPORTES
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            sx={style}
                            focused
                            size="small"
                            label="Importe total"
                            fullWidth
                            value={totalMuestro}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="text"
                            sx={style}
                            focused
                            size="small"
                            label="Otros"
                            fullWidth
                            value={otrostributos}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            sx={style}
                            focused
                            size="small"
                            label="Importe Neto Gravado"
                            fullWidth
                            value={neto}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            sx={style}
                            focused
                            size="small"
                            label="Saldo No Aplicado"
                            fullWidth
                            value={saldonoaplic}
                            error={saldoNegativo}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            sx={style}
                            focused
                            size="small"
                            label="IVA Total"
                            value={ivaTotal}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

//========================================================================
/*----- Component --------------------------------------------------------/
// Developer     : Candela Grosso   
// Creation Date : 23/05/2024
// Version       : 1.0  
// Description   :  Componente con el formulario con los calculos para  guardar en la tabla pie_comprobante
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description: 
//========================================================================*/
